import React, { useState } from 'react';
import {
  Typography, FormGroup, FormControlLabel, Checkbox, Button, Box, Alert
} from '@mui/material';
import DateRangeFilter, { defaultStart, defaultEnd } from './DateRangeFilter';
import { ExportVisits } from '../../../api';

const FIELDS = [
  { key: 'ownerName', label: 'Owner' },
  { key: 'petName', label: 'Pet' },
  { key: 'phone', label: 'Phone' },
  { key: 'email', label: 'Email' },
  { key: 'parkingSpace', label: 'Parking Space' },
  { key: 'vehicle', label: 'Vehicle' },
  { key: 'reason', label: 'Reason' },
  { key: 'subreason', label: 'Subreason' },
  { key: 'source', label: 'Source' },
  { key: 'comment', label: 'Comment' },
  { key: 'payment', label: 'Payment' },
  { key: 'pickup', label: 'Pickup' },
  { key: 'createdAt', label: 'Time In' },
  { key: 'acknowledgedAt', label: 'Acknowledged At' },
  { key: 'completedAt', label: 'Checked Out At' },
  { key: 'answers', label: 'Custom Answers' },
];

const Export = ({ access }) => {
  const [start, setStart] = useState(defaultStart());
  const [end, setEnd] = useState(defaultEnd());
  const [selected, setSelected] = useState(FIELDS.map(f => f.key));
  const [error, setError] = useState('');

  const toggle = key =>
    setSelected(s => s.includes(key) ? s.filter(k => k !== key) : [...s, key]);

  const run = () => {
    setError('');
    ExportVisits(access?.org?.id, { start, end, fields: selected })
      .then(blob => {
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `visits-${start}-${end}.csv`;
        a.click();
        URL.revokeObjectURL(url);
      })
      .catch(() => setError('Export failed'));
  };

  return (
    <>
      <Typography variant="h6" sx={{ mb: 2 }}>CSV Export</Typography>
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      <DateRangeFilter start={start} end={end} onStart={setStart} onEnd={setEnd} onSubmit={run} />
      <Typography variant="subtitle2" sx={{ mb: 1 }}>Fields to include:</Typography>
      <FormGroup row>
        {FIELDS.map(f => (
          <FormControlLabel
            key={f.key}
            control={<Checkbox checked={selected.includes(f.key)} onChange={() => toggle(f.key)} size="small" />}
            label={f.label}
            sx={{ width: 200 }}
          />
        ))}
      </FormGroup>
      <Box sx={{ mt: 2 }}>
        <Button variant="contained" onClick={run}>Download CSV</Button>
      </Box>
    </>
  );
};

export default Export;
